import React from 'react'

export default function Infrastructure(){
  return (
    <main>
      {/* Page Header */}
      <section className="container-fluid page-banner black-banner" style={{background: 'url(/img/4.jpeg) center', height: '580px', backgroundSize: 'cover', backgroundPositionY: '54%'}}>
        <div className="container py-5">
          <div className="row align-items-center py-4">
            <div className="col-md-6 text-center text-md-left">
              <h1 className="display-4 mb-4 mb-md-0 text-secondary">Infrastructure</h1>
            </div>
            {/* <div className="col-md-6 text-center text-md-right">
              <div className="d-inline-flex align-items-center">
                <a className="btn btn-sm btn-outline-light" href="/">Home</a>
                <i className="fas fa-angle-double-right text-light mx-2"></i>
                <a className="btn btn-sm btn-outline-light disabled" href="">Infrastructure</a>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Manufacturing System Section */}
      <section className="py-5" style={{backgroundColor: '#f5f5f0'}}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="mb-4 section-title" style={{color: '#5d4037'}}>Manufacturing System</h2>
              <p className="text-muted">
                Lakulish Pharmaceutical is one of the rapidly growing pharmaceutical companies as a result of its combined strength in research and manufacturing. Our associate manufacturing facilities follow strict GMP guidelines.
              </p>
              <p className="text-muted ">
              We have recently established a state-of-the-art nutraceutical manufacturing facility for Tablets, Capsules, Softgel Capsules, Sachets, and Powders, designed and operated in compliance with international regulatory standards such as USFDA, WHO-GMP, and ISO guidelines.
              </p>
              <p className="text-muted ">
                We are committed to provide High quality Generic as well as Ethical Medications, our manufacturing partners have been rewarded with WHO GMP, NAFDAC, Kenya, Ghana, Cameroon, Tanzania, DPML-Ivory Coast and Our most of associated units are approved by EU GMP, USFDA and PIC/S. ISO 9001 certifications.
              </p>
              <p className="text-muted ">
                We take precautions to ensure that all facilities, from design to maintenance follow the highest international standards. Cross contamination at any level is avoided by quarantined production blocks with independent air systems.
              </p>

              <p className="text-muted">We manufacture in accordance with stringent international quality standards. Our standards are regularly verified through audits conducted by clients and international authorities.</p>
              <p className="text-muted">Our combination of service options, capabilities, expertise and facilities provides clients a distinct advantage. Our operational staffs are highly educated and heavily trained in GMP and the most current trends.</p>

              </div>
            </div>
          </div>
      </section>

      {/* Infrastructure Gallery - Sliding Window of 3 Images */}
      <section className="py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-4 font-weight-bold mb-4" style={{color: '#5d4037'}}>Our Facilities</h2>
            <p className="lead text-muted">State-of-the-art manufacturing and quality control facilities</p>
          </div>

          <div id="facilitiesCarousel" className="carousel slide" data-ride="carousel" data-interval="5000">
            <div className="carousel-inner">
              {/* Slide 1: Facilities 1, 2, 3 */}
              <div className="carousel-item active">
                <div className="row justify-content-center g-3">
                  <div className="col-lg-4 col-md-4">
                    <div className="card border-0 shadow-lg h-100">
                      <div className="card-header text-center py-3" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                        <h6 className="card-title mb-0 font-weight-bold">Manufacturing Facility 1</h6>
                      </div>
                      <img src="/img/infra1.jpg" className="card-img-bottom" alt="Infrastructure Facility 1" style={{height: '280px', objectFit: 'cover'}} />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <div className="card border-0 shadow-lg h-100">
                      <div className="card-header text-center py-3" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                        <h6 className="card-title mb-0 font-weight-bold">IPQC Inspection Area</h6>
                      </div>
                      <img src="/img/infra2.jpg" className="card-img-bottom" alt="Infrastructure Facility 2" style={{height: '280px', objectFit: 'cover'}} />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <div className="card border-0 shadow-lg h-100">
                      <div className="card-header text-center py-3" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                        <h6 className="card-title mb-0 font-weight-bold">Production Area</h6>
                      </div>
                      <img src="/img/infra3.jpg" className="card-img-bottom" alt="Infrastructure Facility 3" style={{height: '280px', objectFit: 'cover'}} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 2: Facilities 2, 3, 4 */}
              <div className="carousel-item">
                <div className="row justify-content-center g-3">
                  <div className="col-lg-4 col-md-4">
                    <div className="card border-0 shadow-lg h-100">
                      <div className="card-header text-center py-3" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                        <h6 className="card-title mb-0 font-weight-bold">Quality Control Lab</h6>
                      </div>
                      <img src="/img/infra2.jpg" className="card-img-bottom" alt="Infrastructure Facility 2" style={{height: '280px', objectFit: 'cover'}} />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <div className="card border-0 shadow-lg h-100">
                      <div className="card-header text-center py-3" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                        <h6 className="card-title mb-0 font-weight-bold">Production Area</h6>
                      </div>
                      <img src="/img/infra3.jpg" className="card-img-bottom" alt="Infrastructure Facility 3" style={{height: '280px', objectFit: 'cover'}} />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <div className="card border-0 shadow-lg h-100">
                      <div className="card-header text-center py-3" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                        <h6 className="card-title mb-0 font-weight-bold">Packaging Facility</h6>
                      </div>
                      <img src="/img/infra4.jpg" className="card-img-bottom" alt="Infrastructure Facility 4" style={{height: '280px', objectFit: 'cover'}} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 3: Facilities 3, 4, 5 */}
              <div className="carousel-item">
                <div className="row justify-content-center g-3">
                  <div className="col-lg-4 col-md-4">
                    <div className="card border-0 shadow-lg h-100">
                      <div className="card-header text-center py-3" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                        <h6 className="card-title mb-0 font-weight-bold">Production Area</h6>
                      </div>
                      <img src="/img/infra3.jpg" className="card-img-bottom" alt="Infrastructure Facility 3" style={{height: '280px', objectFit: 'cover'}} />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <div className="card border-0 shadow-lg h-100">
                      <div className="card-header text-center py-3" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                        <h6 className="card-title mb-0 font-weight-bold">Packaging Facility</h6>
                      </div>
                      <img src="/img/infra4.jpg" className="card-img-bottom" alt="Infrastructure Facility 4" style={{height: '280px', objectFit: 'cover'}} />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <div className="card border-0 shadow-lg h-100">
                      <div className="card-header text-center py-3" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                        <h6 className="card-title mb-0 font-weight-bold">Storage & Warehouse</h6>
                      </div>
                      <img src="/img/infra5.jpg" className="card-img-bottom" alt="Infrastructure Facility 5" style={{height: '280px', objectFit: 'cover'}} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Carousel Controls */}
            <a className="carousel-control-prev" href="#facilitiesCarousel" role="button" data-slide="prev" style={{width: '8%', opacity: '0.8'}}>
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="sr-only">Previous</span>
            </a>
            <a className="carousel-control-next" href="#facilitiesCarousel" role="button" data-slide="next" style={{width: '8%', opacity: '0.8'}}>
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>
      </section>

      {/* Quality Control Section */}
      <section className="py-5" style={{backgroundColor: '#f5f5f0'}}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="mb-4 section-title" style={{color: '#5d4037'}}>Quality Control</h2>
              <p className="lead text-muted">
                In line with our quality policy, we have set up quality functions across the organization to consistently monitor the process operations for assuring the quality, safety and efficacy of our products in the export markets.
              </p>
              <p className="text-muted">
                Our Quality Management Systems (QMS) complies with various international regulatory and cGMP standards and we perform periodic reviews of systems, practices and documentation in place across our manufacturing facilities through regular audits.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contract Manufacturing Alliance */}
      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="mb-4 section-title" style={{color: '#5d4037'}}>Contract Manufacturing Alliance</h2>

              <div className="card border-0 shadow-sm mb-4" style={{backgroundColor: '#f5f5f0'}}>
                <div className="card-body">
                  <h4 className="card-title mb-3" style={{color: '#5d4037'}}>
                    <i className="fas fa-handshake text-primary mr-2"></i>Comprehensive Manufacturing Services
                  </h4>
                  <p className="text-muted mb-3">We offer Contract Manufacturing of all dosage forms.</p>
                  <p className="text-muted mb-3">Depending on needs of our valued clients, our services include purchasing of raw materials, production, packaging and quality control.</p>
                  <p className="text-muted mb-0">Through this flexible approach, we are able to integrate perfectly into supply chains, monitor and optimize the timeliness of our delivery and keep it up to our customer's full satisfaction.</p>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <div className="card border-0 shadow-sm h-100">
                    <div className="card-body">
                      <h4 className="card-title mb-3" style={{color: '#5d4037'}}>
                        <i className="fas fa-industry text-success mr-2"></i>Expertise & Capabilities
                      </h4>
                      <p className="text-muted">
                        Our expertise in the pharmaceutical industry has been augmented through our production capabilities, highly qualified production & quality control staff. With highly integrated production facilities comes the capability to manage a flexible production line. This empowers us with the capability to undertake contract manufacturing projects.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="card border-0 shadow-sm h-100">
                    <div className="card-body">
                      <h4 className="card-title mb-3" style={{color: '#5d4037'}}>
                        <i className="fas fa-users text-info mr-2"></i>Partnership Approach
                      </h4>
                      <p className="text-muted">
                        As a privately-owned and fully independent pharmaceutical formulation company, we offer flexible terms of trade with individual attention to each customer. We solve the challenges of working with an extended design chain so as to facilitate a productive & profitable outsourcing partnership for our customers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card border-0 shadow-sm mt-4" style={{backgroundColor: '#f5f5f0'}}>
                <div className="card-body">
                  <h4 className="card-title mb-3" style={{color: '#5d4037'}}>
                    <i className="fas fa-lock text-warning mr-2"></i>Secure Information Management
                  </h4>
                  <p className="text-muted">
                    We capture and process all the product definitions provided by customer's information through a secure online environment that makes a convenient setting for sharing information. Secure and easy, this system allows for customers to easily share information internally. Also, we invite partners and suppliers to view work with information-with as many access barriers as they choose to keep.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Plant Locations */}
      {/* <section className="py-5" style={{backgroundColor: '#f5f5f0'}}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="mb-4 section-title" style={{color: '#5d4037'}}>Manufacturing Plant Locations</h2>
              <div className="card border-0 shadow-sm">
                <div className="card-body text-center">
                  <i className="fas fa-map-marked-alt fa-3x text-primary mb-3"></i>
                  <h4 className="card-title mb-3" style={{color: '#5d4037'}}>Strategic Locations</h4>
                  <p className="text-muted mb-0">
                    We can provide details if you need our manufacturing plant information for business deals. We have different locations of our manufacturing plants established. So we can expand business reach to target into industry.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </main>
  )
}
